import React from "react";

const ContactCard = () =>{
    return(
        <div>
            <div class="row">
                <div class="col s12 m12">
                    <div class="card blue-grey darken-1">
                        <div class="card-content white-text">
                            <span class="card-title">Contact</span>
                            <p>If you have any questions, give us a call!</p>
                        </div>
                        <div className="card-action">
                            <ul>
                                <li className ="white-text padding-top"><h5> Hablamos Español</h5></li>
                                <br></br>
                                <li className ="orange-text">PHONE: 702-366-4826 </li>
                                <br></br>
                                <li className ="orange-text">EMAIL: Progressconcrete@gmail.com </li>
                                <br></br>
                                <li className ="orange-text">WHATSAPP: 702-366-4826 </li>
                                <br></br>
                            </ul>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactCard;


